export default __webpack_public_path__ + "static/media/about_img.c5d4dd05.webp";